export const getPathUid = () => {
    const pathname = window.location.pathname.replace('/', '');
    const parts = pathname.split('/');
    const pathUid = parts[parts.length - 1].split('?')[0];

    return pathUid;
}